import {uploadFile} from "../form/uploadFile";
import {showRangeScale} from "../form/showRangeScale";
import {setPrice} from "../form/setPrice";
import {toggleFormDefaultAnimation} from "../form/toggleFormDefaultAnimation";

export function initFormDefault() {
    const service = document.getElementById('form-service'),
        company = document.getElementById('form-company'),
        file = document.getElementById('formUpload');

    const btnReset = document.querySelector('.end .btn-reset'),
        btnApply = document.querySelector('.end .btn-apply'),
        btnRange = document.querySelector('.end .btn-range');

    const rangeScale = document.querySelector('.end .range__scale'),
        rangeScaleBtn = document.querySelectorAll('.end input[name="price"]');

    $( "#form-service" ).selectmenu({
        open: function (event, ui) {
            toggleFormDefaultAnimation(false);
            if (window.innerWidth < 905) {
                company.closest('label').classList.toggle('selectmenu-open-mobile');
            }
        },
        close: function (event, ui) {
            toggleFormDefaultAnimation(true);
            if (window.innerWidth < 905) {
                company.closest('label').classList.remove('selectmenu-open-mobile');
            }
        }
    });

    $( "#range-mobile" ).selectmenu({
        open: function (event, ui) {
            service.nextElementSibling.classList.toggle('selectmenu-open-mobile');
        },
        close: function (event, ui) {
            service.nextElementSibling.classList.remove('selectmenu-open-mobile');
        }
    });

    file.addEventListener('change', function (evt) {
        uploadFile(evt, file, btnReset)
    })

    btnReset.addEventListener('click', function (evt) {
        uploadFile(evt, file, btnReset)
    });

    btnRange.addEventListener('click', function (evt) {
        showRangeScale(evt, file)
    });

    btnApply.addEventListener('click', function (evt) {
        setPrice(evt, file, rangeScaleBtn,rangeScale,  btnRange)
    });
}
